/**
 * Skip Ads - Adblocker for YouTube
 *
 * Declares `images/*` web-accessible on `<all_urls>`, but the directory ships nothing, so
 * there is no probeable resource. Its content script — scoped to YouTube — does leave a
 * mark, though: on load it injects `<style id="yt-extension-style">` and keeps it present
 * unless the user disables the extension. Found by reading the content script; the
 * injection retries until `<head>` exists, so it is unconditional on any YouTube page.
 *
 * The `yt-extension-style` id is the extension's own, so it identifies this extension
 * specifically. Detectable only from a YouTube origin, where the content script runs.
 * Behavioural, so it only fires while the extension is active.
 *
 * Observed on version 1.1.6.
 */

import { probeSelector } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'lkahpjghmdhpiojknppmlenngmpkkfma';

export const skipAdsYoutube: ExtensionDefinition = {
  id: ID,
  name: 'Skip Ads - Adblocker for YouTube',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 80_000,
  requiredOrigin: 'https://www.youtube.com',
  requiresRealPage: true,
  interactive: true,
  notes:
    'Detected behaviourally on YouTube: injects style#yt-extension-style on load and ' +
    'keeps it present. The declared images/* WAR ships nothing, so this DOM marker is ' +
    'the signal. Needs the real YouTube page for the content script to run.',
  signals: [
    {
      id: 'dom-yt-extension-style',
      kind: 'dom',
      description:
        'Look for style#yt-extension-style — the stylesheet the extension injects on ' +
        'every YouTube page and leaves in place while enabled.',
      weight: 1,
      run: () => probeSelector('style#yt-extension-style', { timeoutMs: 4000 }),
    },
  ],
};
